export default {
  apiUrl: process.env.VUE_APP_API_URL
}